import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import TransfersPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/TransfersPage";
import AddUnlinkedTransferAccountForm from "components/workflows/AddUnlinkedTransferAccountWorkflow/classes/AddUnlinkedTransferAccountForm";
import AddUnlinkedTransferAccountFormUI from "components/workflows/AddUnlinkedTransferAccountWorkflow/classes/AddUnlinkedTransferAccountFormUI";
import Classes, { Account } from "model";
import React, { useEffect } from "react";

/**
 * @name CaptureToAccountDDOpen
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Unlinked Accounts" (abi22).
 */
export default function CaptureToAccountDDOpen(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasConsumerAccounts = Account.hasConsumerAccounts(branding);
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    const defaultData = getDefaultPageData();
    const defaultUnlinkedAcc = BCMSDefaultModel.unlinkedAccount();
    const newAccountNumber = "1500306800";
    defaultUnlinkedAcc.type = "unlinked";
    defaultUnlinkedAcc.id = "100";
    defaultUnlinkedAcc.nickname = defaultUnlinkedAcc.accountOwnerFirstName;
    defaultUnlinkedAcc.number = Account.formatAccountNumber(newAccountNumber);
    defaultUnlinkedAcc.accountOwnerType = hasConsumerAccounts ? "personal" : "business";
    defaultUnlinkedAcc.activeRow = true;

    const form = AddUnlinkedTransferAccountForm.init({
        accountNickname: defaultUnlinkedAcc.accountOwnerFirstName,
        accountOwnerType: defaultUnlinkedAcc.accountOwnerType,
        firstNameOfAccountOwner: defaultUnlinkedAcc.accountOwnerFirstName,
        lastNameOfAccountOwner: defaultUnlinkedAcc.accountOwnerLastName,
        accountType: defaultUnlinkedAcc.subtype,
        accountNumber: newAccountNumber,
        confirmAccountNumber: newAccountNumber
    }, branding);

    // This formUI class handles shown/removed fields from branding.
    const formUI = AddUnlinkedTransferAccountFormUI.init(form, branding);

    defaultUnlinkedAcc.accountOwnerFirstName = formUI.firstNameOfAccountOwner ? defaultUnlinkedAcc.accountOwnerFirstName : "";
    defaultUnlinkedAcc.accountOwnerLastName = formUI.lastNameOfAccountOwner ? defaultUnlinkedAcc.accountOwnerLastName : "";
    defaultUnlinkedAcc.accountOwnerType = formUI.accountOwnerType ? defaultUnlinkedAcc.accountOwnerType : "";

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "transfer", "from" ], checkingAccount)
    .update([ "allToAccounts" ], [ ...defaultData.allToAccounts, defaultUnlinkedAcc ])
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI(undefined, context))
    .update([ "to", "isActive" ], true)
    .submit();

    useEffect(() => {
        // Set a timeout since Chromium (capture system OS) loads fonts after components render,
        // so the dropdown content height changes.
        // We need to scroll to the bottom of the dropdown content.
        setTimeout(() => {
            const toSelectDropdown = document.querySelector(`[data-point="Transfers_To"] .custom-select-dropdown`);
            if(toSelectDropdown) toSelectDropdown.scrollTo(0, toSelectDropdown.scrollHeight);
        }, 500);
        
        Util.replaceDOMDataPointValues(branding);
    });

    return <TransfersPage data={ data } ui={ ui } />
}